import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FaPlay, 
  FaQuestionCircle, 
  FaRocket, 
  FaLightbulb,
  FaMagic,
  FaArrowRight,
  FaMousePointer,
  FaDrawPolygon,
  FaDoorOpen,
  FaExpandArrowsAlt
} from 'react-icons/fa';
import './WelcomeScreen.css';


const WelcomeScreen = () => {
  const navigate = useNavigate();
  const [currentTip, setCurrentTip] = useState(0);

  const quickTips = [
    {
      icon: <FaMousePointer />,
      title: "Select & Move",
      description: "Use the select tool to move and resize shapes",
      shortcut: "S"
    },
    {
      icon: <FaDrawPolygon />,
      title: "Draw Rooms",
      description: "Create rectangular, circular, or triangular rooms",
      shortcut: "R"
    },
    {
      icon: <FaDoorOpen />,
      title: "Add Doors",
      description: "Place rotatable doors that snap to room walls",
      shortcut: "D"
    },
    {
      icon: <FaExpandArrowsAlt />,
      title: "Zoom & Pan",
      description: "Use zoom controls or mouse wheel to navigate",
      shortcut: "Scroll"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTip((prev) => (prev + 1) % quickTips.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [quickTips.length]);

  const features = [
    {
      icon: <FaRocket />,
      title: "Professional Design",
      description: "Create detailed floor plans with precision tools and measurements"
    },
    {
      icon: <FaMagic />,
      title: "Smart Doors",
      description: "Rotatable doors that automatically snap to room walls for realistic layouts"
    },
    {
      icon: <FaLightbulb />,
      title: "Carpet Estimation",
      description: "Advanced carpet calculation with cutting diagrams and cost analysis"
    }
  ];

  return (
    <div className="welcome-screen">
      {/* Background Elements */}
      <div className="background-patterns">
        <div className="pattern-circle"></div>
        <div className="pattern-square"></div>
        <div className="pattern-triangle"></div>
      </div>

      {/* Header */}
      <header className="welcome-header">
        <div className="logo-container">
       
          <div className="logo-text">
          <div className="logo-icon-large">
           <img src="/floor-planner-logo.jpeg" height="200" width="200" style={{objectFit:'contain'}}/>
          </div>
           
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="welcome-main">
        <div className="welcome-content">
          {/* Hero Section */}
          <section className="hero-section">
            <h2>Create Professional Floor PlanZ</h2>
            <p>Design detailed floor layouts with smart tools, and advanced carpet estimation capabilities.</p>
            
            <div className="cta-buttons">
              <button 
                className="primary-btn"
                onClick={() => navigate('/planner')}
              >
                <FaPlay />
                <span>Start Planning</span>
                <FaArrowRight className="arrow-icon" />
              </button>
              
              <button 
                className="secondary-btn"
                onClick={() => navigate('/instructions')}
              >
                <FaQuestionCircle />
                <span>View Instructions</span>
              </button>
            </div>
          </section>

          {/* Features Grid */}
          <section className="features-section">
            <h3>Key Features</h3>
            <div className="features-grid">
              {features.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon">
                    {feature.icon}
                  </div>
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Quick Tips */}
          <section className="tips-section">
            <h3>Quick Tips</h3>
            <div className="tips-carousel">
              <div className="tip-card active">
                <div className="tip-icon">
                  {quickTips[currentTip].icon}
                </div>
                <div className="tip-content">
                  <h4>{quickTips[currentTip].title}</h4>
                  <p>{quickTips[currentTip].description}</p>
                  <span className="tip-shortcut">
                    Press <kbd>{quickTips[currentTip].shortcut}</kbd>
                  </span>
                </div>
              </div>
              
              <div className="tip-indicators">
                {quickTips.map((_, index) => (
                  <button
                    key={index}
                    className={`tip-indicator ${index === currentTip ? 'active' : ''}`}
                    onClick={() => setCurrentTip(index)}
                  />
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="welcome-footer">
        <div className="footer-content">
          <p>&copy; 2024 Floor Planz Pro. Professional floor planning made simple.</p>
          <div className="footer-links">
            <button onClick={() => navigate('/instructions')}>Help</button>
            <button onClick={() => navigate('/planner')}>Get Started</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default WelcomeScreen; 